window.onload = () => {
    ScrollTrigger.refresh();
};
  
gsap.registerPlugin(ScrollTrigger, SplitText);

/*=============================================
=           Hero Banner Animation             =
=============================================*/

window.addEventListener("load", () => {
    const fadeIn = gsap.timeline({ defaults: { ease: "power2.out", duration: 1.6 } });

    fadeIn.fromTo(".header-slider .swiper-slide .slider-media img",
        { scale: 1.02, opacity: 0.8 },
        { scale: 1, opacity: 1, duration: 1.0 },
        0
    );

    // Heading
    fadeIn.fromTo(".header-slider .slider-content .heading-block",
        { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)" },
        { opacity: 1, clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0)" },
        ">-2.4"
    );

    // Text
    fadeIn.fromTo(".header-slider .slider-content .text-block",
        { opacity: 0 },
        { opacity: 1 },
        ">-1.3"
    );

    // Button
    fadeIn.fromTo(".header-slider .slider-content .btn",
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0 },
        ">+0.03"
    );
});



/*=============================================
=       Outside The Ordinary Animation        =
=============================================*/

gsap.timeline({
    scrollTrigger: {
      trigger: ".media_banner_with_text",
      start: "top 95%",
      toggleActions: "play none none none"
      // markers: true
    }
})

// Text
.fromTo(".media_banner_with_text .container > .group-block > .heading-block.h6",
    { opacity: 0 },
    { opacity: 1, ease: "power2.out", duration: 1.2 },
    ">-1"
)

// Heading
.fromTo(".media_banner_with_text .group-block .heading-block.h4",
    { opacity: 0, clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)" },
    { opacity: 1, ease: "power2.out", duration: 1.3, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)" },
    ">-1.3"
);




/*=============================================
=         Commercial Spaces Animation         =
=============================================*/

gsap.timeline({
    scrollTrigger: {
        trigger: ".commercial-spaces .commercial-image-block",
        start: "top 70%",
        toggleActions: "play none none none"
        // markers: true
    }
})
  
// Animate main commercial image
.fromTo(".commercial-spaces .commercial-image-block",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 1.6, ease: "power2.inOut" },
    ">-2"
)

// Animate each element one by one with fast timing (button first, then richtext-block, h6, h2)
.fromTo(
    ".commercial-spaces .commercial-space-wrapper .btn",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 0.55, ease: "power2.out" },
    ">-0.4" // starts 0.3s after image animation
)

.fromTo(
    ".commercial-spaces .commercial-space-wrapper .richtext-block",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 0.55, ease: "power2.out" },
    ">-0.3" // starts 0.2s after button animation
)

.fromTo(
    ".commercial-spaces .commercial-space-wrapper h2",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 0.55, ease: "power2.out" },
    ">-0.2" // starts 0.2s after h6 animation
)

.fromTo(
    ".commercial-spaces .commercial-space-wrapper h6",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 0.55, ease: "power2.out" },
    ">-0.125" // starts 0.2s after richtext-block animation
)
  
// Animate last image
.fromTo(".commercial-spaces .commercial-space-image",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 1.6, ease: "power2.inOut" },
    ">-1.5" // starts after button animation completes
);



/*=============================================
=          Meet Big Timber Animation          =
=============================================*/

gsap.timeline({
    scrollTrigger: {
      trigger: ".meet-big-timber .fade-in-first", // start trigger
      start: "top 65%",
      toggleActions: "play none none none"
      // markers: true // debug
    }
})
.fromTo(".meet-big-timber .fade-in-first",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 1, ease: "power2.inOut" },
    ">-2"
)
.fromTo(".meet-big-timber .fade-in-second",
    { opacity: 0, clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" },
    { opacity: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", duration: 1.3, ease: "power2.inOut" },
    "+=0.1" // small delay between first & second (adjust as needed)
);